import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../../providers/withRouter";
import { toast } from "react-toastify";
import { Grid } from "@mui/material";
import { getFinca, getOnlyAAFF, nuevoCentroTrabajo } from "../../../services";
import BreadCrumb from "../../../components/navbar/Breadcrumb";

const NuevoCentroTrabajo = (props) => {
  const { t } = useTranslation('common');
  const [nombre, setNombre] = useState("");
  const [finca, setFinca] = useState([]);
  const [aaff, setAaff] = useState([]);
  useEffect(() => {
    getFinca(props.params.nifFinca).then((res) => {
      setFinca(res);
      if (res?.aaff?.nif) {
        getOnlyAAFF(res.aaff.nif).then(aaff => {
          setAaff(aaff)
        })
      }
    });

  }, []);

  const crearCentroTrabajo = (e) => {
    e.preventDefault();
    let data = {
      razonSocial: nombre,
    };
    nuevoCentroTrabajo(props.params.nifFinca, data)
      .then((res) => {
        if (res.message === "WORKCENTER_CREATED") {
          toast.success(t('workCenter.messages.created'));
          const nifDestino = res.aaff_nif || aaff?.nif || finca?.aaff?.nif;
          if (nifDestino) {
            window.location.replace("/aaff/" + nifDestino + "/comunidades");
          } else {
            window.location.replace("/aaff");
          }
        } else {
          toast.error(t('workCenter.messages.createError'));
        }
      })
      .catch((err) => {
        toast.error(t('workCenter.messages.error'));
        console.log(err);
      });
  };

  return (
    <>
      {/* <div
        className="pageHeader"
        style={{
          backgroundImage: `url(${HeaderBackground})`,
          textAlign: "left",
        }}
      >
        Nuevo centro de trabajo
      </div> */}
      <BreadCrumb rutas={[{path:'/aaff', label: t('aaff:titleSingular')}, {path:`/aaff/${aaff?.nif}/comunidades`, label:`${aaff?.razonSocial}`}, {path:`/aaff/${aaff?.nif}/comunidades`, label:`${finca?.razonSocial}`}]} style={{ margin: '0 10px'}} />
      <div className="pageContent">
        <div className="titleContent">{t('workCenter.createNew')}</div>
        <form className="nuevoAAFFForm" onSubmit={crearCentroTrabajo}>
          <Grid
            container
            spacing={5}
            style={{ marginTop: 20, marginBottom: 20 }}
          >
            <Grid item xs={12} sm={6}>
              <input
                type="text"
                required
                placeholder={t('form.name')}
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
              ></input>
            </Grid>
          </Grid>
          <input type="submit" value={t('actions.save')}></input>
        </form>
      </div>
    </>
  );
};

export default withRouter(NuevoCentroTrabajo);
